export default {
  statistics: {
    total_campaigns: 'Total des campagnes',
    todays_sent_messages: "Messages envoyés aujourd'hui",
    total_subscribers: 'Abonnés',
    average_click_rate: 'Taux de clics moyen',
  },
};
